import { isFacebookAdTraffic } from './eventTracking.js'
import { shouldReportPlatformPixel } from './pixelDomainPolicy.js'
import { parseSiteConfigData } from './siteSeo.js'

export const FACEBOOK_ADS_ONLY_TRACKING_CONFIG_KEY = 'facebookAdsOnlyTracking'

const normalizeBoolean = (value) => {
  if (value === true || value === 1) return true
  if (typeof value !== 'string') return false

  return ['1', 'true'].includes(value.trim().toLowerCase())
}

export function isFacebookAdsOnlyTrackingEnabled(configData) {
  const parsedConfigData = parseSiteConfigData(configData)
  return normalizeBoolean(parsedConfigData?.[FACEBOOK_ADS_ONLY_TRACKING_CONFIG_KEY])
}

export function shouldReportFacebookTracking(configData) {
  if (!shouldReportPlatformPixel(configData, 'meta')) {
    return false
  }

  return !isFacebookAdsOnlyTrackingEnabled(configData) || isFacebookAdTraffic()
}
